//import statement
import React from 'react'
import { Row, Col } from 'react-bootstrap'
import Logo from '../assets/logo.png'
import { Link } from 'react-router-dom'

import { FaDiscord, FaTwitter } from 'react-icons/fa'
//functional component
const Header = () => {


    return (
        <Row className='header justify-content-end'>
            <Col xs="12" md='4' sm='6' className='text-center'>
                <Link to="/">
                    <img src={ Logo } height={ 100 } width={ "auto" } alt="logo" />
                </Link>

            </Col>
            <Col xs="12" md='4' sm='6' className=' text-center text-sm-right mt-3 '>
                <a href='https://discord.gg/thefracture ' target='_blank'>  <FaDiscord color='white' className='mx-1' size={ 25 } /> </a>
                <a href='https://twitter.com/TheFracture_' target='_blank'>  <FaTwitter color='white' className='mx-1' size={ 25 } /> </a>
            </Col>

        </Row>
    )
}
export default Header